<script>
  /**
   * cardlist (array)= [ ['nom',valeur], [ ]...]
   * color = orange , green
   */
  export let cardObject ;
</script>

 <div class="container" >
        <div class="row">
            <div class="col-12 cadre  cardStd cardEntete cardMiddle" class:cardEnteteIndivi={cardObject.IM_INDIVISION==1}>
                {cardObject.IM_NOM} - ({cardObject.IM_INDIVISION})
            </div>
        </div>

        <div class="row">
            <div class="col-6 cadre cardLittle cardMiddle" class:cardLittleIndivi={cardObject.IM_INDIVISION==1}>
            <br/>
                <span class="valeur"> {cardObject.IM_TYPE_PROP}</span><br/>
            </div>
            <div class="col-6  cadre cardLittle cardMiddle" class:cardPret={cardObject.IM_PRET_MT!=0} class:cardLittleIndivi={cardObject.IM_INDIVISION==1}>
                <h5 class="">Prêt</h5>
                <span class="valeur "> {new Intl.NumberFormat("fr-FR").format(Math.round(cardObject.IM_PRET_MT))}</span><br/>
                <span class="label "> {cardObject.IM_FIN_PRET}</span>
            </div>
        </div>

        <div class="row">
            <div class="col-6 cadre cardLittle cardMiddle" class:cardLittleIndivi={cardObject.IM_INDIVISION==1}>
                <h5>Loyer</h5>
                <span class="valeur "> {cardObject.IM_MT_LOYER}</span><br/>
            </div>
            <div class="col-6 cadre cardLittle cardMiddle" class:cardLittleIndivi={cardObject.IM_INDIVISION==1}>
                <h5>Agence</h5>
                <span class="valeur "> {cardObject.IM_AGENCE}</span><br/>
            </div>
        </div>


        <div class="row">
            <div class="col-4 cadre cardLittle cardMiddle " class:cardLittleIndivi={cardObject.IM_INDIVISION==1}>
                <h5>D.Achat</h5>
                <span class="valeur"> {cardObject.IM_DATE_ACHAT}</span>
            </div>
            <div class="col-4 cadre cardLittle cardMiddle " class:cardLittleIndivi={cardObject.IM_INDIVISION==1}>
                <h5>D.Vente</h5>
                <span class="valeur"> {cardObject.IM_DATE_VTE}</span>
            </div>
            <div class="col-4 cadre cardLittle cardMiddle " class:cardLittleIndivi={cardObject.IM_INDIVISION==1}>
                <h5>Vendu ?</h5>
                <span class="valeur"> {cardObject.IM_VENDU}</span>
            </div>
        </div>

         <div class="row">
            <div class="col-6 cadre cardLittle cardMiddle " class:cardLittleIndivi={cardObject.IM_INDIVISION==1}>
                <h5>Px.achat</h5>
                <span class="valeur"> {new Intl.NumberFormat("fr-FR").format(Math.round(cardObject.IM_PA))}</span>
            </div>
            <div class="col-6 cadre cardLittle cardMiddle " class:cardLittleIndivi={cardObject.IM_INDIVISION==1}>
                <h5>Px. Vte</h5>
                <span class="valeur"> {new Intl.NumberFormat("fr-FR").format(Math.round(cardObject.IM_PX_VTE))}</span>
            </div>
        </div>

        <div class="row">
            <div class="col-12 cadre  cardStd cardLittle" class:cardLittleIndivi={cardObject.IM_INDIVISION==1}>
                <h5>{cardObject.IM_COMMENT}</h5>
            </div>
        </div>

    </div>
<br/><br/>
<style>

    .cadre{
       -webkit-border-radius: 10px 10px 10px 10px;
    -moz-border-radius: 10px 10px 10px 10px;
      border: 1px solid rgb(252, 250, 250);
           margin-bottom: 4px;
             padding: 7px;
}

    .cardStd {

    width: 100%;
}

.cardLittle {
    background: #669ce2;
}
.cardEntete {
    background: #04469c;
    color:white;
}

.cardLittleIndivi {
    background: #b7f5c0;
}
.cardEnteteIndivi {
    background: #026716;
    color:white;
}
.cardPret{
   background: #f6b74b;
}
.cardMiddle{
     text-align: center;
}
.valeur{
   font-weight: 500;
}
h5{
    font-size: 0.75rem;
    font-weight: 200;
}
</style>
